import { useLegacyAutoPayStore } from './useLegacyAutoPayStore'
import { useOneTimePaymentStore } from './useOneTimePaymentStore'

export const CardPaymentsStore = {
  useLegacyAutoPay: useLegacyAutoPayStore,
  useOneTimePayment: useOneTimePaymentStore,
}
